import { render } from "./PortfolioDevelopment.vue?vue&type=template&id=33471645&scoped=true"
import script from "./PortfolioDevelopment.vue?vue&type=script&lang=js"
export * from "./PortfolioDevelopment.vue?vue&type=script&lang=js"

import "./PortfolioDevelopment.vue?vue&type=style&index=0&id=33471645&scoped=true&lang=css"
import "./PortfolioDevelopment.vue?vue&type=style&index=1&id=33471645&scoped=true&lang=css"
import "./PortfolioDevelopment.vue?vue&type=style&index=2&id=33471645&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33471645"]])

export default __exports__